<div class="w-100 text-center">
                <img src="assets/images/tetherfi-logo-round.png" data-bs-toggle="tooltip" />
                <br />

    <img alt="No Data" class="" src="assets/images/no-data.svg" />
    <p class="text-primary mt--20"> {{ errorMsg }} </p>

</div>
          